import listActions from 'src/modules/producer/list/producerListActions';
import ProducerService from 'src/modules/producer/producerService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import Message from 'src/view/shared/message';
import { navigateTo } from 'src/view/shared/routes/helpers';

const prefix = 'PRODUCER_DESTROY';

const producerDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: producerDestroyActions.DESTROY_STARTED,
      });

      await ProducerService.destroyAll([id]);

      dispatch({
        type: producerDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(i18n('entities.producer.destroy.success'));

      dispatch(listActions.doFetchCurrentFilter());

      navigateTo('/library/producer');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: producerDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: producerDestroyActions.DESTROY_ALL_STARTED,
      });

      await ProducerService.destroyAll(ids);

      dispatch({
        type: producerDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doChangeSelected([]));
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(i18n('entities.producer.destroyAll.success'));

      navigateTo('/library/producer');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: producerDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default producerDestroyActions;
